import {
  formatExpenseFeeMoney,
  formatExpenseFeeTaxBreakdownLine,
  resetExpenseFeeTaxSelection,
} from '@/composables/expensesFees/shared/useExpenseFeeTaxFlow';

export const resetPaymentPlanTaxSelection = (form = {}) => resetExpenseFeeTaxSelection(form);

export const formatPaymentPlanMoney = (value, currencyCode = 'MXN') => {
  return formatExpenseFeeMoney(value, currencyCode);
};

export const formatPaymentPlanTaxBreakdownLine = (item, currencyCode = 'MXN') => {
  return formatExpenseFeeTaxBreakdownLine(item, currencyCode);
};
